import React from 'react'
import LowArrow from '../../../../../../../images/lowArrow.png'
import HighArrow from '../../../../../../../images/highArrow.png'

export const CustomTableRow = (props) => {
  return (
    <button
      className={!props.disabled ? "highlow-table-row" : "highlow-table-row highlow-table-row-disabled"}
      id="highlow-table-row"
      onClick={props.onClick}
    >
      <p className="date">{props.date}</p>
      <div className="toggle-container">
        <img className="toggle" src={(props.status === 'lower') ? LowArrow : HighArrow} alt='arrow'/>
      </div>
      <p className="target">{props.protein}g</p>
      <p className="target">{props.carbs}g</p>
      <p className="target">{props.fat}g</p>
      <p className="target">{props.calories}</p>
    </button>
  );
};
